var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "f324f457e0d9f35c107de2818ef7400f2d915939"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["frontend-nextrequest@nextrequest"] = {
  id: "f324f457e0d9f35c107de2818ef7400f2d915939"
};